import React from "react";

// ===============================
// CONSTANTS
// ===============================
const PROJECT_STAT_CARDS = [
  {
    key: "total",
    label: "Total Projects",
    valueKey: "total",
    bgColor: "bg-primary/10",
    textColor: "text-primary-dark",
  },
  {
    key: "completed",
    label: "Completed",
    valueKey: "completed",
    bgColor: "bg-green-50",
    textColor: "text-green-700",
  },
  {
    key: "inProgress",
    label: "In Progress",
    valueKey: "inProgress",
    bgColor: "bg-blue-50",
    textColor: "text-blue-700",
  },
  {
    key: "onHold",
    label: "On Hold",
    valueKey: "onHold",
    bgColor: "bg-yellow-50",
    textColor: "text-yellow-700",
  },
  {
    key: "cancelled",
    label: "Cancelled",
    valueKey: "cancelled",
    bgColor: "bg-red-50",
    textColor: "text-red-700",
  },
];

// ===============================
// COMPONENT
// ===============================
const StatisticsCards = ({ statusCounts }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-2 lg:gap-3">
      {PROJECT_STAT_CARDS.map(
        ({ key, label, valueKey, bgColor, textColor }) => (
          <div key={key} className={`${bgColor} rounded-lg p-3 text-center`}>
            <div className={`text-lg font-bold ${textColor}`}>
              {statusCounts[valueKey] || 0}
            </div>
            <div className="text-xs text-gray-600">{label}</div>
          </div>
        )
      )}
    </div>
  );
};

export default StatisticsCards;
